export const TIMEPICKER_SCROLLABLE_VARIANTS = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  AM_PM: 'am_pm'
};
export const timeFormat = 'hh:mm TT';
export const DEFAULT_TIME_12_HOUR_FORMAT = 'HH:MM AM';
export const DEFAULT_TIME_24_HOUR_FORMAT = 'HH:MM';